import { apiClient } from "../../base/ApiClient";

const BASE_URL = "/core";

export const documentService = {
  getCategories: async () => {
    const response = await apiClient.get(`${BASE_URL}/categories/`);
    return response.data;
  },

  getDocuments: async (category, search) => {
    const params = new URLSearchParams();
    if (category) params.append("category", category);
    if (search) params.append("search", search);
    
    const response = await apiClient.get(`${BASE_URL}/documents/?${params.toString()}`);
    return response.data;
  },

  createCategory: async (data) => {
    const response = await apiClient.post(`${BASE_URL}/categories/`, data);
    return response.data;
  },

  updateCategory: async (id, data) => {
    const response = await apiClient.patch(`${BASE_URL}/categories/${id}/`, data);
    return response.data;
  },

  deleteCategory: async (id) => {
    const response = await apiClient.delete(`${BASE_URL}/categories/${id}/`);
    return response.data;
  },

  createDocument: async (data) => {
    const response = await apiClient.post(`${BASE_URL}/documents/create_from_url/`, data);
    return response.data;
  },

  deleteDocument: async (id) => {
    const response = await apiClient.delete(`${BASE_URL}/documents/${id}/`);
    return response.data;
  },

  incrementView: async (id) => {
    const response = await apiClient.post(`${BASE_URL}/documents/${id}/increment_view/`);
    return response.data;
  },

  incrementDownload: async (id) => {
    const response = await apiClient.post(`${BASE_URL}/documents/${id}/increment_download/`);
    return response.data;
  },
};